export const property = {
  gamefi: "GameFi",
  mc_official_verify_unofficial: "Непроверенный источник",
  mc_official_verify_official: "Официальный ",
  mc_official_verify_fotter_tip_1:
    "Напоминание о рисках по предотвращению мошенничества в Интернете / по телефону со стороны фальшивых сотрудников Biking",
  mc_official_verify_fotter_tip_2:
    "Официальный представитель Biking объявляет предупреждение о риске для предотвращения мошенничества",
  mc_official_verify_modal_tip_1:
    "Ваш запрос [{query}] является официальным каналом Biking в Канал",
  mc_official_verify_modal_tip_3:
    "Убедитесь, что введенная вами информация и формат верны:",
  mc_official_verify_modal_tip_4: "Номер телефона: xx-xxxxxxxxx",
  mc_official_verify_modal_type_email: "Электронная почта",
  mc_official_verify_modal_type_domain: "Домен",
  mc_official_verify_modal_type_channel: "Канал",
  mc_official_verify_input_placeholder:
    "Введите информацию в правильном формате для проверки",
  mc_official_verify_head_title:
    "Верификация официальных каналов биржи Biking | Биржа Biking",
  mc_official_verify_head_description:
    "Верификация официальных каналов биржи Biking",
  mc_official_verify_title: "Верификация Biking",
  mc_official_verify_discription_new:
    "На этой странице вы можете проверить, является ли URL-адрес, адрес электронной почты, номер телефона или аккаунт в социальных сетях, таких как X и Telegram, проверенным официальным источником Biking. Это поможет вам избежать потери ваших активов по причине фишинга и онлайн-мошенничества.",
  mc_official_verify_fotter_tip_3:
    "Обязательная информация для всех пользователей Biking: Руководство по предотвращению мошенничества. Остерегайтесь мошенников!",
  mc_unofficial_verify_modal_tip_1:
    "Ваш запрос [{query}] не является проверенным официальным источником Biking",
  mc_official_verify_discription:
    "Чтобы предотвратить мошенничество от имени Biking, ниже можно подтвердить, является канал официальным или нет. Каналы включают X, Facebook, Telegram, номер телефона, WeChat и др.",
  mc_official_head_title1:
    "Проверка официальных каналов, новостей и публикаций Biking",
  mc_official_head_keywords1:
    "верификация Biking, новости Biking, официальный аккаунт Biking",
  mc_official_head_description1:
    "Убедитесь в подлинности сообщений Biking. Используйте наш официальный инструмент верификации, чтобы подтвердить легитимность каналов, новостей и публикаций, связанных с Biking.",
  mc_official_verify_verified_title: "Проверенный официальный источник",
  mc_official_verify_modal_tip_5:
    "Telegram/X/Facebook/Youtube: @xxxxx (с символом @)",
  mc_official_verify_modal_tip_6: "TikTok/Instagram: xxxx (без символа @)",
  mc_official_verify_modal_tip_7: "Discord: xxxx#xxxx (без символа @)",
  mc_official_verify_modal_tip_8:
    "LinkedIn/Telegram group/Medium/Reddit: https://xxxxx (ссылка на сайт)",
  mc_official_verify_modal_tip_9:
    "Если у вас есть вопросы о формате, пожалуйста, обратитесь в Службу поддержки клиентов.",
  mc_official_verify_modal_tip_10:
    "*Не раскрывайте никому информацию о своей учетной записи и пароль.",
  mc_official_verify_modal_tip_11:
    "*Остерегайтесь мошенников и действуйте осторожно. ",
  tagtip:"Se a plataforma de depósito não solicitar o preenchimento do campo Comentário, este campo pode ser deixado em branco.",
  tagtip1:"A tag é um código exclusivo usado para identificar uma conta ou usuário específico, garantindo que os fundos sejam enviados ao destinatário correto.",
  tag: "Por favor, insira um comentário",
  qbcbcg:
    "Por favor, copie tanto o endereço TON quanto o comentário para garantir um depósito bem-sucedido.",
  qsrzqje: "Por favor, insira o valor correto",
  games: "conta de jogo",
  cbxz: "Aviso de Depósito Ethereum (ERC20)",
  tbxz: "Aviso de Retirada para Ethereum (ERC20)",
  ctbzysx:
    "Por favor, observe que há uma taxa adicional de 2% para cada transferência do contrato inteligente oficial da FUFU.",
  dzcw: "Endereço Errado",
  czqkqrs: "Confirmações do Bloco de Depósito",
  mc: "Nome",
  cjsj: "Data de Criação",
  lx: "Tipo",
  sl: "Quantidade",
  cwjl: "Registros Financeiros",

  ylzh: "Lucro",
  ddtx: "Aguardando Saque",
  txcg: "Saque Realizado",
  yhcx: "Usuário Cancelou",
  qbcbjl: "Todos os Registros de Depósito",

  zczl: "Visão Geral de Ativos",
  mozh: "Conta de Demonstração",
  mnhy: "Contrato Simulado",
  zjzh: "Conta de Saldo",
  mbzh: "Conta de Compra",
  xhzh: "Conta Spot",
  hyzh: "Conta de Contrato Futuro",
  lczh: "Conta de Earn",
  gdzh: "Conta de Cópia de Transação",
  giftzh: "Conta de Presente",
  bwzh: "Cartão Rei Moeda",
  sxffy: "Comissão do Sistema",
  kt: "Airdrop",
  xtkc: "Dedução do Sistema",
  zcfb: "Distribuição de Ativos",
  zcdt: "Dinâmica de Ativos",
  zh: "Conta",
  zc: "Ativo",
  czjl: "Registro de Depósito",
  txls: "Histórico de Saque",
  hzjl: "Registro de Transferência",
  mmjl: "Registro de Compra e Venda",
  cb: "Depósito",
  tx: "Saque",
  hz: "Transferência",
  mb: "Comprar",
  jy: "Negociar",
  zwsj: "Sem Dados Disponíveis",
  ckqb: "Ver Todos",

  // table
  bz: "Moeda",
  qc: "Nome Completo",
  zhze: "Saldo Total",
  syzc: "Ativo Restante",
  djzc: "Ativo Congelado",
  cz: "Operação",
  sl: "Quantidade",
  cbdz: "Endereço de Depósito",
  sj: "Data e Hora",
  zt: "Status",
  ms: "Descrição",
  hzfx: "Direção da Transferência",
  hzse: "Valor Transferido",
  txdz: "Endereço de Saque",
  sxf: "Taxa de Transação",
  ddh: "Número do Pedido",
  zj: "Valor Total",
  dj: "Preço Unitário",
  jysl: "Quantidade Negociada",
  jydx: "Contraparte da Transação",
  zhqy: "Patrimônio da Conta",
  zhqytips: "Patrimônio da Conta = Margem Disponível + Margem de Posição",
  kybzj: "Margem Disponível",
  kybzjtips: "Margem disponível para abrir posições e transferências",
  cwbzj: "Margem de Posição",
  cwbzjtips: "Usado para manter as posições existentes",

  // search
  srbz: "Digite o nome da moeda correspondente",
  ycxzc: "Ocultar Pequenos Ativos",
  sy: "Todos",
  qb: "Tudo",
  qx: "Tudo",
  zhi: "a",
  ksrq: "Data de Início",
  jsrq: "Data de Término",
  cx: "Pesquisar",
  dc: "Exportar",
  zjqt: "Últimos 7 dias",
  zjygy: "Último mês",
  qbsj: "Todo o Período",
  usdt: "USDT",
  ddlx: "Tipo de Pedido",
  gm: "Comprar",
  cs: "Vender",

  // recharge
  czxq: "Detalhes do Depósito",
  usdtcbjl: "Registro de Depósito {coinName}",
  cbsl: "Quantidade de Depósito",
  cbzt: "Status do Depósito",
  crdbz: "Selecione a moeda que deseja depositar",
  tqdbz: "Selecione a moeda que deseja sacar",
  rmbz: "Moedas Populares",
  qxz: "Selecione",
  cbwl: "Rede de Depósito",
  cbtips:
    "Certifique-se de que você selecionou a rede de depósito consistente com a plataforma de saque para evitar perdas de ativos.",
  txfs: "Método de Saque",
  lstx: "Saque On-Chain",
  xyb: "Próximo Passo",
  yxzdq: "Você selecionou o atual",
  dbz: "moeda",
  cxxz: "Escolher Novamente",
  dzkbz:
    "O endereço da biblioteca de endereços está insuficiente, entre em contato com o administrador",
  qxzcrdbz: "Por favor, selecione a moeda que deseja depositar primeiro",
  qxzcbwl: "Por favor, selecione a rede de depósito",
  qxztqdbz: "Por favor, selecione a moeda que deseja sacar primeiro",
  cr: "Depósito",
  tq: "Saque",
  cbxq: "Detalhes do Depósito",
  txxq: "Detalhes do Saque",
  usdttxjl: "Registro de Saque {coinName}",
  qbtxjl: "Todos os Registros de Saque",
  zyxx: "Informações Importantes: você só pode enviar {coinName} para este endereço. Se enviar outras criptomoedas, você perderá esses fundos.",
  jzjcr: "Depositar para",
  smewm:
    "Digitalize o código QR ou copie as seguintes informações para a plataforma de saque",
  xcdzcz:"Depositar moedas diferentes deste tipo neste endereço resultará na perda de seus ativos",
  xcdzczss:"Ao depositar XRP, certifique-se de copiar a tag, caso contrário poderá ocorrer perda de fundos.",
  znhycz:
    "Atualmente não suporta depósitos de contratos inteligentes, depósitos em pacotes e recompensas de blocos",
  usdtcbdz: "Endereço de Depósito {coinName}",
  fzdz: "Copiar Endereço",
  usdtdz: "Endereço {coinName}",
  zxcbe: "Quantidade Mínima de Depósito",
  zytx2:
    "Informações Importantes: Certifique-se de que a plataforma de saque suporta a rede {coinName} que você escolheu, caso contrário, você perderá esses fundos.",
  kytxwl: "Redes de Saque Disponíveis para {coinName}",
  xzwl: "Escolha a Rede",
  dzym: "Endereço {coinName}",
  srdz: "Digite o endereço ou selecione-o na lista de contatos",
  jymm: "Senha de Transação",
  qsrjymm: "Digite sua senha de transação",
  zxtbe: "Quantidade Mínima de Saque: {minAmount}",
  ky: "Disponível:",
  zhztbxe: "Limite Total de Saque na Conta",
  gjxyddj:
    "Com base no seu nível de verificação, você tem um limite de saque nas últimas 24 horas. Esse limite é calculado convertendo em dólares americanos a moeda que você selecionou.",
  scbdjd:
    "Devido à grande volatilidade do preço da moeda, a taxa de saque é flutuante. Com base no preço médio da moeda nas últimas 24 horas, a taxa varia de 0,2 a 0,2 USDT e aumenta para acelerar o saque",
  yqdz: "Chegada Estimada",
  yqdzwf: "A chegada estimada não pode ser negativa",
  sfrz: "Verificação de Identidade",
  ggyzm: "Código de Verificação do Google",
  dxyzm: "Código de Verificação por SMS",
  yxyzm: "Código de Verificação por E-mail",
  qsryzm: "Digite o Código de Verificação",
  fsyzm: "Enviar",
  cxfs: "Reenviar",
  tj: "Enviar",
  qxztxwl: "Selecione a rede de saque",
  qsrdz: "Digite o endereço de saque",
  qxzdz: "Por favor, selecione um endereço",
  qxzyzfs: "Selecione um método de autenticação",
  qsrtqsl: "Por favor, insira a quantidade a ser extraída",
  qwcyz: "Por favor, conclua a verificação",
  qqrbdsj: "Por favor, confirme se deseja vincular seu telefone celular primeiro",
  qqrbdyx: "Por favor, confirme se deseja vincular seu endereço de e-mail primeiro",
  fzcg: "Cópia bem-sucedida!",
  tbcg: "Retirada bem-sucedida",
  usdttxdz: "endereço de retirada {coinName}",
  lmc: "Nome da cadeia:",
  qtj: "*Por favor adicione",
  dz: "endereço",
  fei: "não",
  zjds: "O endereço pode causar perda de ativos",
  yzfs: "Método de verificação",
  yzm: "Código de verificação",
  remark: "Observações",
  qsrremark: "Por favor, insira observações",
  tjdzcg: "Endereço adicionado com sucesso",
  qxxzyzfs: "Selecione primeiro o método de verificação",
  qsrtxdz: "Por favor, insira o endereço de retirada",
  stop: "Pausa",

  // status
  qr0: "0 Confirmações",
  qr1: "1 Confirmação",
  dqr: "Pendente de Confirmação",
  czcg: "Depósito Concluído",
  hzz: "Em Processo de Transferência",
  ywc: "Concluído",
  sb: "Falha",
  zzcl: "Em Processamento",
  ddsh: "Aguardando Aprovação",
  txcg: "Saque Concluído",
  cxcg: "Cancelamento Concluído",
  ddtx: "Aguardando Saque",
  txsb: "Falha no Saque",
  slsb: "Falha na Transação de Bloco",
  dfk: "Aguardando Pagamento",
  yfk: "Pagamento Realizado",
  yqx: "Cancelado",
  ssz: "Em Disputa",
  gdfrhz: "Transferência de Lucro de Cópia de Transação",
  hyzh_to_gdzh: "Conta de Contrato Futuro - Conta de Cópia de Transação",
  gdzh_to_hyzh: "Conta de Cópia de Transação - Conta de Contrato Futuro",
  ddcl: "Aguardando Processamento",
  cg: "Concluído",

  // dialog
  zchz: "Transferência de Ativos",
  ljhz: "Transferir Agora",
  cong: "De",
  dao: "Para",
  qtzh: "Outra Conta",
  qxzbz: "Selecione a Moeda",
  qsrsl: "Digite a Quantidade",
  khz: "Quantidade Disponível:",
  ye: "Saldo:",
  hzcg: "Transferência Concluída",

  // h5
  zcgl: 'Visão Geral de Ativos',
  xrzx: 'Ofertas Exclusivas para Novos Usuários',
  zzc: 'Ativo Total',
  jryk: 'Lucro/Perda Hoje',
  zgjz: 'Pacote de Presente de Novo Usuário no valor de 3200 USDT aguardando por você',
  zhrj: 'Faça um Depósito em Sua Conta',
  xzrjfs: 'Depois do depósito, você poderá comprar criptomoedas. Escolha o método de depósito de acordo com sua situação.',
  czszhb: 'Depósito de Criptomoedas',
  yyydszhb: 'Deposite suas criptomoedas de outras plataformas para sua conta da Biking.',
  czfb: 'Depósito de Moeda Fiat',
  czzhz: 'Deposite suas moedas fiat para sua conta da Biking. Suporta várias formas de pagamento, como cartão bancário e transferência.',
  maibi: 'Comprar Criptomoedas',
  tgdsfmb: 'Compre criptomoedas através de cartão bancário, P2P e outros métodos.',
  yqyl: 'Programa de Indicação',
  yqfy: 'Convide amigos e ganhe 20% de comissão',
  cxzzn: 'Guia para Iniciantes',
  czzh: 'Crie uma Conta da Biking',
  hdxrj: 'Ganhe um bônus de 100 USDT para novos usuários',
  ck: 'Depósito',
  tzndzh: 'Invista em sua conta e comece sua jornada, suportando diversos métodos de pagamento',
  wcsfrz: 'Conclua a verificação de identidade (KYC)',
  hgzh: 'Conclua a verificação de identidade (KYC) e torne-se um usuário verificado',
  ksjy: 'Comece a Negociar',
  tsgd: 'Venda, compre ou copie negociações e explore mais',
  ksndlc: 'Comece sua jornada',
  kjydjmhb: 'Criptomoedas Disponíveis para Negociação',
  jmhb: 'O valor total de mercado das criptomoedas é de 12.284,85 bilhões de dólares',
zengjin: "presente",
  lc: "gestão financeira",
  mb: "comprar moedas",
  lsjl: "História",
  zclb: "Lista de ativos",
  shaixuan: "filtro",
  tagtip1: 'A tag é um código exclusivo usado para identificar uma conta ou usuário específico, garantindo que os fundos sejam enviados ao destinatário correto.',
  tagtip2: 'Outras plataformas de negociação ou carteiras podem se referir ao Tag como ID Digital, Tag, Memo, Nota, Observação ou Comentário.',
  批量导入地址:'Importar endereços em lotes',
  请输入地址或名称:'Por favor insira o endereço ou nome',
  地址名称:'nome do endereço',
  上传普通地址:'Carregar endereço normal',
  上传成功:'Carregamento bem-sucedido',
  一次只能上传一个文件哦:'Apenas um arquivo pode ser carregado por vez',
  文件大小不得超过10M:'O tamanho do arquivo não deve exceder 10M',
  请先选择要上传的文件:'Selecione o arquivo para enviar primeiro',
  只能上传后缀是:'Somente arquivos com o sufixo .xlsx ou .xls ou .csv podem ser carregados',
  将文件拖到此处:'Arraste os arquivos aqui ou',
  点击上传:'Clique para carregar',
  最大1MB:'Arquivos CSV, XLS, XLSX de até 1 MB',
  编号:'número de série',
  所属网络:'Pertencente à rede',
  地址簿:'livro de endereços',
  新增地址:'Adicionar endereço',
  提币地址一次不超过100个:'O número de endereços de retirada de uma vez não deve exceder 100',
  添加地址:'Adicionar endereço',
  保存地址:'salvar endereço',
  下载模板:'Baixar modelo',
  批量提现:'Retirada em lote',
  请输入Memo:'Por favor insira o memorando',
  请输入地址名称:'Por favor insira o nome do endereço',
  输入正确地址可添加地址成功:'Introduza o endereço correto para adicionar o endereço com sucesso',
  您可以通过:'Você pode fazer upload de até 20 endereços comuns através de arquivos nos formatos CSV, XLS ou XLSX (máximo 1MB). O título de cada coluna deve ser consistente com o modelo, caso contrário o upload falhará.'
}



// WEBPACK FOOTER //
// ./src/i18n/lang/property/pt_BR.js